jQuery(function(){

	jQuery('body').on('click', '.radio-image', function(e){
		var $container = jQuery(this);
		var $radio = $container.find('input');
		$radio.prop('checked', true);

		return false;
	});

});
